/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "UsersBatchImportPageService";
const log: any = LoggerModule.getInstance();

export class UsersBatchImportPageService {
  private static instance: UsersBatchImportPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): UsersBatchImportPageService {
    if (!UsersBatchImportPageService.instance) {
      UsersBatchImportPageService.instance = new UsersBatchImportPageService(
        props
      );
    }
    return UsersBatchImportPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async uploadUsers(group: any) {
    const agent = getAgent();
    return agent.createUserUpload(group);
  }
}
